import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './NotFound.css';

function NotFound() {
  return (
    <div className="app-container">
      <Header />
      
      <nav className="main-nav">
        <div className="nav-container">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/about" className="nav-link">About</Link>
        </div>
      </nav>
      
      <main className="main-content">
        <div className="not-found-container">
          <div className="not-found-content">
            <div className="american-eagle"></div>
            <h1>404 - Page Not Found</h1>
            <p>The page you're looking for doesn't exist or has been moved.</p>
            <div className="not-found-actions">
              <Link to="/" className="not-found-btn">Return to Home</Link>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}

export default NotFound;